module.exports = __webpack_public_path__ + "media/promo/advent/images/cells/cell-21-9e2ed573eb0a8c861627e3bda46c2930.png";